import React, {useCallback, useEffect, useMemo, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import Container from '@mui/material/Container';
import {
    addressQueryString,
    calculateCartTotalPrice,
    calculateTransferPrice,
    currencySymbol,
    price,
    scrollTop,
} from "../../../../config/values";
import {connect, setStore} from "trim-redux";
import {updateRedux} from "../../../../config/Security";
import PaymentPageSkeleton from "../../../components/loaders/PaymentPageSkeleton";
import SubTitle from "../../../components/elements/SubTitle";
import ViewDeliveryAddress from "../../../components/address/components/ViewDeliveryAddress";
import ViewDeliveryTime from "./components/ViewDeliveryTime";
import {Alert, AlertTitle, Box, Button, IconButton, Switch, Typography} from "@mui/material";
import AddDiscountCodeDialogButton from "./components/AddDiscountCodeDialogButton";
import RayaField from "../../../components/elements/fields/RayaField";
import LoadingButton from "../../../components/elements/LoadingButton";
import ViewCartItemsButton from "./components/ViewCartItemsButton";
import {CircleCheck, CreditCard, MoveLeft, TicketPercent, Wallet, Package, HandCoins, Banknote} from "lucide-react";
import Title from "../../../components/elements/Title";
import CheckoutPageSkeleton from "../../../components/loaders/CheckoutPageSkeleton";
import clsx from "clsx";
import CheckoutPaymentCardsPanel from "./components/CheckoutPaymentCardsPanel";
import AcceptedCardBrandsStrip from "../../wallet/components/AcceptedCardBrandsStrip";
import {
    PAYMENT_GATEWAYS,
    cardsApiPath,
    fetchPaymentGateway,
    openIyzicoThreeDsHtml,
    payPagePath,
    startGatewayPayment,
} from "../../../../config/paymentGateway";
import { ensureIyzicoEmailOrRedirect } from "../../../../config/iyzicoEmail";

function CheckoutPage({classes,setting,user,isAuth,selected_time}){
    const { t } = useTranslation();
    //let { code } = useParams();

    const [data, setData] = useState([]);
    const [discountCode, setDiscountCode] = useState(null);
    const [consumeCharge, setConsumeCharge] = useState(false);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [fields, setFields] = useState({
        description: '',
    });
    const [cartTotalPrice,setCartTotalPrice] = useState(null);
    const [cartTransferPrice,setCartTransferPrice] = useState(null);
    const [totalPrice,setTotalPrice] = useState(null);
    const [errors, setErrors] = useState({});
    const [paymentCards, setPaymentCards] = useState([]);
    const [paymentCardsLoading, setPaymentCardsLoading] = useState(false);
    const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState(null);
    const navigation = useNavigate();
    const loginToken = localStorage.getItem("ACT");
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`,
        }
    }
    const { enqueueSnackbar } = useSnackbar();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const loadData = () =>{
        setFetching(true);
        axios.get(`${defaultVariables.url}/checkout/info${addressQueryString()}`,config)
            .then(response => {
                setData(response.data);
                if(response.data.check !== "ok"){
                    enqueueSnackbar(response.data.check, { variant: 'warning' });
                    setLoading(false);
                    setFetching(false);
                    setTimeout(() => {
                        navigation(-1)
                    }, 1000);
                }else{
                    updateRedux();
                    setLoading(false);
                    setFetching(false);
                }

            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
                setFetching(false);
                setStore({error:404})
            });
    }
    useEffect(() => {
        if (!isAuth) {
            navigation('/');
            return;
        }
        scrollTop();
        loadData();
    }, []);

    useEffect(() => {
        if (data?.check !== 'ok' || !data?.shop) {
            return;
        }
        const carts = Array.isArray(data.carts) ? data.carts : [];
        const cart_total_price = parseFloat(calculateCartTotalPrice(carts));
        const transfer_price = parseFloat(calculateTransferPrice(cart_total_price, data.shop));
        const total_price = cart_total_price + transfer_price;
        setCartTotalPrice(cart_total_price);
        setCartTransferPrice(transfer_price);
        setTotalPrice(total_price);
    }, [data]);

    const [checkoutGateway, setCheckoutGateway] = useState(PAYMENT_GATEWAYS.param);

    useEffect(() => {
        if (data?.check !== "ok" || !data?.shop?.id) {
            return;
        }
        if (data.shop.payment_gateway) {
            setCheckoutGateway(data.shop.payment_gateway);
            return;
        }
        fetchPaymentGateway({
            context: "order",
            shopId: data.shop.id,
            token: loginToken,
        })
            .then((r) => setCheckoutGateway(r?.gateway || PAYMENT_GATEWAYS.param))
            .catch(() => setCheckoutGateway(PAYMENT_GATEWAYS.param));
    }, [data?.check, data?.shop?.id, data?.shop?.payment_gateway, loginToken]);

    const needsCardPayment = useMemo(() => {
        if (data?.check !== "ok" || !data?.shop) {
            return false;
        }
        if (data.shop.is_pod) {
            return false;
        }
        const walletAmt = Number(user?.wallet?.amount || 0);
        const tp = Number(totalPrice);
        if (Number.isNaN(tp) || tp <= 0) {
            return false;
        }
        if (!consumeCharge) {
            return true;
        }
        return walletAmt < tp;
    }, [data, user?.wallet?.amount, consumeCharge, totalPrice]);

    const loadPaymentCards = useCallback(() => {
        if (!needsCardPayment || !loginToken) {
            setPaymentCards([]);
            setPaymentCardsLoading(false);
            return;
        }
        setPaymentCardsLoading(true);
        axios
            .get(cardsApiPath(checkoutGateway), {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${loginToken}`,
                },
            })
            .then((r) => {
                const list = Array.isArray(r.data) ? r.data : [];
                setPaymentCards(list);
            })
            .catch(() => {
                setPaymentCards([]);
            })
            .finally(() => setPaymentCardsLoading(false));
    }, [needsCardPayment, loginToken, checkoutGateway]);

    useEffect(() => {
        loadPaymentCards();
    }, [loadPaymentCards]);

    useEffect(() => {
        if (!needsCardPayment) {
            setSelectedPaymentMethodId(null);
            return;
        }
        setSelectedPaymentMethodId((sel) => {
            if (!paymentCards.length) {
                return null;
            }
            if (sel != null && paymentCards.some((c) => c.id === sel)) {
                return sel;
            }
            const def = paymentCards.find((c) => c.is_default);
            if (def) {
                return def.id;
            }
            return paymentCards[0].id;
        });
    }, [needsCardPayment, paymentCards]);

    const handleDiscountCode = (code) => {
        setDiscountCode(code);
        if(!!code?.total_discount_price){
            setTotalPrice(totalPrice - code?.total_discount_price);
        }else{
            setTotalPrice(cartTotalPrice + cartTransferPrice);
        }
    }
    const handleRequest = async () => {
        setSubmitLoading(true);
        const data = new FormData();
        data.append('description', fields.description);
        data.append('has_wallet', !!consumeCharge ? 1 : 0);
        data.append('order_time', selected_time);
        if(!!discountCode){
            data.append('discount_code', discountCode.code);
        }
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/orders/make${addressQueryString()}`, data, config);
            let res = response.data;
            localStorage.removeItem('charity_name');
            localStorage.removeItem('charity_slug');
            if (!!res.is_pod) {
                setSubmitLoading(false);
                window.location.replace(`/account/view-order/${res.number}`);
                return;
            }
            localStorage.setItem("payment_redirect_url", `/account/view-order/${res.number}`);
            localStorage.setItem("payment_redirect_text", t('viewOrder'));
            if (res.status === "pending") {
                setSubmitLoading(false);
                window.location.replace(`/view/transaction/web/wallet/${res.transaction.unique_code}`);
                return;
            }
            const gatewayNeedsPayment =
                needsCardPayment && res.transaction?.id != null && res.id != null;
            if (gatewayNeedsPayment) {
                if (selectedPaymentMethodId == null) {
                    setSubmitLoading(false);
                    enqueueSnackbar(t("checkoutPickCardWarning"), { variant: "warning" });
                    return;
                }
                if (
                    !ensureIyzicoEmailOrRedirect({
                        gateway: checkoutGateway,
                        user,
                        enqueueSnackbar,
                        navigate: navigation,
                        t,
                    })
                ) {
                    setSubmitLoading(false);
                    return;
                }
                try {
                    const payRes = await startGatewayPayment({
                        walletHistoryId: res.transaction.id,
                        paymentMethodId: selectedPaymentMethodId,
                        platform: "web",
                        orderId: res.id,
                        token: loginToken,
                    });
                    setSubmitLoading(false);
                    if (payRes?.three_ds && payRes?.html_content) {
                        openIyzicoThreeDsHtml(payRes.html_content);
                        return;
                    }
                    if (payRes?.redirect_url) {
                        window.location.href = payRes.redirect_url;
                        return;
                    }
                } catch (payErr) {
                    setSubmitLoading(false);
                    const msg = payErr.response?.data?.message || t("paramPayFailed");
                    enqueueSnackbar(msg, { variant: "error" });
                }
                navigation(payPagePath(checkoutGateway, res.transaction.id, res.id));
                return;
            }
            setSubmitLoading(false);
            navigation(payPagePath(checkoutGateway, res.transaction.id, res.id));
        } catch (error) {
            console.error(error);
            setSubmitLoading(false);
            if (error.response?.status === 422) {
                enqueueSnackbar(error.response.data, { variant: "warning" });
            }
        }
    };
    const charity_name = localStorage.getItem('charity_name');
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('checkout')}>
            <div className="page-color-layout">
                {
                    !!loading ?
                        <Container maxWidth="xl" >
                            <CheckoutPageSkeleton/>
                        </Container>
                        :
                        <>
                            <Container maxWidth="xl"  className={classes.checkoutItem}>
                                <Grid container spacing={2} justifyContent="center" style={{marginTop:100,marginBottom:50}}>
                                    <Grid item size={{xs:12,lg:8}} >
                                        <Grid container spacing={2}>
                                            <Grid item size={12}>
                                                <div className="flex-space">
                                                    <SubTitle align="left"><strong>{t('checkout')}</strong></SubTitle>
                                                    <Button
                                                        startIcon={<MoveLeft/>}
                                                        color="text"
                                                        onClick={() => navigation(-1)}
                                                    >
                                                        {t('back')}
                                                    </Button>
                                                </div>
                                            </Grid>
                                            <Grid item size={12}>
                                                <Box className={classes.checkoutSectionPanel}>
                                                    <SubTitle align="left">{t('deliveryAddress')}</SubTitle>
                                                    <ViewDeliveryAddress address={user.address}/>
                                                    {
                                                        data?.shop.transfer_by === "system" ?
                                                            <Typography color="secondary" className="mt-10">{t('transferBySystemDesc')}</Typography>
                                                            :
                                                            <Typography color="secondary" className="mt-10">{t('transferByVendorDesc')}</Typography>
                                                    }
                                                </Box>
                                            </Grid>
                                            <Grid item size={12}>
                                                <Box className={classes.checkoutSectionPanel}>
                                                    <SubTitle align="left">{t('deliveryTime')}</SubTitle>
                                                    <ViewDeliveryTime timing={data?.shop?.timing} shop={data?.shop}/>
                                                </Box>
                                            </Grid>
                                            <Grid item size={12}>
                                                <Box className={classes.checkoutSectionPanel}>
                                                <SubTitle align="left">{t('paymentType')}</SubTitle>
                                                    {
                                                        !!data?.shop?.is_pod  ?
                                                            <>
                                                                <div className={clsx("flex-space","paymentItem")}>
                                                                    <div className="flex-direction">
                                                                        <Banknote className="lucide-icon-text"/>
                                                                        <div className="flex-direction flex-column-md">
                                                                            <Typography><strong>{t('podDesc')}</strong></Typography>
                                                                            <Typography>
                                                                                <Typography>({price(totalPrice)} {currencySymbol})</Typography>
                                                                            </Typography>
                                                                        </div>
                                                                    </div>
                                                                    <CircleCheck className="lucide-large lucide-icon-secondary"/>
                                                                </div>
                                                            </>
                                                            :
                                                            <>
                                                                {
                                                                    !!user.wallet.amount &&
                                                                    <div className="flex-space paymentItem">
                                                                        <div className="flex-direction">
                                                                            <Wallet className="lucide-icon-text"></Wallet>
                                                                            <div className="flex-direction flex-column-md">
                                                                                <Typography><strong>{t('useWallet')}</strong></Typography>
                                                                                <Typography>({price(user.wallet.amount)} {currencySymbol})</Typography>
                                                                            </div>
                                                                        </div>
                                                                        <Switch
                                                                            checked={consumeCharge}
                                                                            color="secondary"
                                                                            onChange={() => setConsumeCharge(!consumeCharge)}
                                                                        />

                                                                    </div>
                                                                }
                                                                <div className={clsx("flex-space","paymentItem",(!!consumeCharge && user.wallet.amount >=  totalPrice) && 'off')}>
                                                                    <div className="flex-direction">
                                                                        <CreditCard className="lucide-icon-text"/>
                                                                        <div className="flex-direction flex-column-md">
                                                                            <Typography><strong>{t('paymentGateway')}</strong></Typography>
                                                                            <Typography>
                                                                                {
                                                                                    !consumeCharge ?
                                                                                        <Typography>({price(totalPrice)} {currencySymbol})</Typography> :
                                                                                        user.wallet.amount <  totalPrice ?
                                                                                            <Typography>({price(totalPrice - user.wallet.amount)} {currencySymbol})</Typography>
                                                                                            : null
                                                                                }
                                                                            </Typography>
                                                                        </div>
                                                                    </div>
                                                                    {needsCardPayment ? <AcceptedCardBrandsStrip variant="inline" /> : null}
                                                                    {
                                                                        (!!consumeCharge && user.wallet.amount >=  totalPrice) ? null :
                                                                            <CircleCheck className="lucide-large lucide-icon-secondary"/>
                                                                    }

                                                                </div>
                                                                {needsCardPayment &&
                                                                needsCardPayment ? (
                                                                    <CheckoutPaymentCardsPanel
                                                                        cards={paymentCards}
                                                                        cardsLoading={paymentCardsLoading}
                                                                        selectedId={selectedPaymentMethodId}
                                                                        onSelectId={setSelectedPaymentMethodId}
                                                                        setCards={setPaymentCards}
                                                                        loginToken={loginToken}
                                                                        enqueueSnackbar={enqueueSnackbar}
                                                                        gateway={checkoutGateway}
                                                                        user={user}
                                                                        navigate={navigation}
                                                                    />
                                                                ) : null}
                                                            </>
                                                    }

                                                </Box>
                                            </Grid>
                                            <Grid item size={12}>
                                                <Box className={classes.checkoutSectionPanel}>
                                                    <div className="flex-space ">
                                                        <div>
                                                            {
                                                                !discountCode ?
                                                                    <>
                                                                        <SubTitle className="mb-md-up-0 " align="left">{t('discountCode')}</SubTitle>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div className="flex-direction">
                                                                            <TicketPercent className="lucide-icon-secondary"/>
                                                                            <Typography style={{color:"green"}}>{discountCode.code}</Typography>
                                                                        </div>
                                                                        <Typography style={{color:"green"}}><strong>{price(discountCode.total_discount_price)} {currencySymbol}</strong> {t('deductedFromOrder')}</Typography>
                                                                    </>
                                                            }
                                                        </div>
                                                        <AddDiscountCodeDialogButton setCode={handleDiscountCode}/>
                                                    </div>
                                                </Box>
                                            </Grid>
                                            <Grid item size={12}>
                                                <RayaField
                                                    variant="outlined"
                                                    multiline
                                                    fullWidth
                                                    name="description"
                                                    label={t('orderDescription')}
                                                    type="text"
                                                    rows="4"
                                                    value={fields.description}
                                                    onChange={handleChange}
                                                    error = {!!errors['description']}
                                                    helperText={errors['description']}
                                                />
                                            </Grid>
                                            <Grid item size={12}>
                                               <Box className={classes.checkoutSectionPanel} style={{boxShadow:"0px 2px 6px rgba(0,0,0,.2)"}}>
                                                   <div className="flex-space mb-10">
                                                       <SubTitle className="mb-0" align="left">{t('orderDetails')}</SubTitle>
                                                       <ViewCartItemsButton carts={data.carts}/>
                                                   </div>
                                                   <div>
                                                       <Typography className="flex-space brd-pay">
                                                           <span>{t('total')}:</span>
                                                           <strong>{price(cartTotalPrice)} {currencySymbol}</strong>
                                                       </Typography>
                                                       <Typography className="flex-space brd-pay">
                                                           <span>{t('transferPrice')}:</span>
                                                           <strong>{
                                                               (cartTransferPrice === 0 || !!discountCode?.free_delivery) ?
                                                                   t('free') :
                                                                   `${cartTransferPrice} ${currencySymbol}`
                                                           }
                                                           </strong>
                                                       </Typography>
                                                       {
                                                           !!discountCode?.discount_price &&
                                                           <Typography color="primary" className="flex-space brd-pay">
                                                               <span>{t('discountPrice')}:</span>
                                                               <strong>{`${discountCode.discount_price} ${currencySymbol}`} </strong>
                                                           </Typography>
                                                       }
                                                       <Typography color="secondary" className="flex-space brd-pay" style={{ borderBottom:"none"}} >
                                                           <span>{t('payable')}:</span>
                                                           <strong>{price(totalPrice)} {currencySymbol}</strong>
                                                       </Typography>
                                                   </div>
                                               </Box>
                                            </Grid>
                                            {
                                                !!charity_name &&
                                                <Grid item size={12}>
                                                <Alert severity="info" variant="filled">
                                                    <AlertTitle>{charity_name}</AlertTitle>
                                                    {t('youAreOrderingFOrCharity')}
                                                </Alert>
                                                </Grid>
                                            }
                                            {
                                                (!!charity_name && !!data?.shop?.is_pod) &&
                                                <Grid item size={12}>
                                                    <Alert severity="warning" variant="filled">
                                                        {t('youAreOrderingFOrCharityIsPod')}
                                                    </Alert>
                                                </Grid>
                                            }
                                            <Grid item size={12}>
                                                <LoadingButton
                                                    className="confirm-btn"
                                                    variant="contained"
                                                    size="large"
                                                    disabled={
                                                        (!!charity_name && !!data?.shop?.is_pod) ||
                                                        (needsCardPayment &&
                                                            (paymentCardsLoading || selectedPaymentMethodId == null))
                                                    }
                                                    onClick={() => handleRequest()}
                                                    loading={submitLoading}
                                                >
                                                    {!!data?.shop?.is_pod ? t("confirmOrder") : t("payOrder")}
                                                </LoadingButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Container>
                        </>

                }
            </div>
        </AppAnimate>
    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
    user: state.user,
    isAuth: state.isAuth,
    selected_time: state.selected_time,
});

export default withStyles(Styles)(connect(mapStateToProps)(CheckoutPage));
